<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'admin',
  created() {
    this.getUserAccount();
    this.getAdminGroupList();
  },
   methods: {
    ...mapActions({
      getUserAccount: 'account/userData',
      getAdminGroupList: 'mail/getAdminGroupList',
    })
  }
}
</script>